import { render, staticRenderFns } from "./AuditoriaDetalhes.vue?vue&type=template&id=dca783d0"
import script from "./AuditoriaDetalhes.vue?vue&type=script&lang=js"
export * from "./AuditoriaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports